import React, { useEffect, useState } from 'react'
import { Card, Container, Row, Col } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import defaultImg from '../../../admin/assets/images/default.png'
import ReactMapGL, { Marker } from "react-map-gl";
import 'mapbox-gl/dist/mapbox-gl.css'
import GlobeLoader from '../../components/GlobeLoader'

export default function SingleProduct() {
    const PF = process.env.REACT_APP_FIND_API_URL + "/images/";
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [viewport, setViewport] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const pageTimeout = setTimeout(() => {
            axios.post(process.env.REACT_APP_FIND_API_URL + `/marketplace/get-single-product/${id}`, {}, { withCredentials: true }).then((res) => {
                console.log(res.data[0]);
                setData(res.data);
                if (res.data[0].seller_store_map_location !== null) {
                    const loc = JSON.parse(res.data[0].seller_store_map_location)
                    const d = loc.map((data) => (data));
                    setViewport({
                        latitude: d[0],
                        longitude: d[1],
                        zoom: 10
                    })
                } else if(res.data[0].service_provider_map_location !== null) {
                    const loc = JSON.parse(res.data[0].service_provider_map_location)
                    const d = loc.map((data) => (data));
                    setViewport({
                        latitude: d[0],
                        longitude: d[1],
                        zoom: 10
                    })
                }

                setLoading(false)
            }).catch((err) => {
                setLoading(false)
            })
        }, 500)
        return () => {
            clearTimeout(pageTimeout)
        }
    }, [id]);

    return (
        <Container>
            {
                loading ? (
                    <GlobeLoader />
                ) :
                    Object.values(data).length > 0 ? (
                        data.map((d) => (<>
                            <div className='d-flex align-items-center gap-2'>
                                <span className='text-secondary'>{d.category_name}</span>
                                <i class='bx bx-chevrons-right'></i>
                                <span>{d.name}</span>
                            </div>
                            <Row className='my-3'>
                                <Col md="8">
                                    <Card className='border-0'>
                                        <Row>
                                            <Col md="7">
                                                <img width={'250px'} height="250px" alt="img" src={d.images === null ? defaultImg : PF + d.images} />
                                            </Col>
                                            <Col md="5">
                                                <h4 className='fs-2'>{d.name}</h4>
                                                <b>Category:</b>
                                                <div className='my-1'>
                                                    <span style={{ background: '#DEE7F1', fontSize: '10px' }} className="py-1 px-2 rounded-5">{d.category_name}</span>
                                                </div>
                                                <div className='my-3'>
                                                    <span className={`${d.discounted_price > 0 ? 'text-decoration-line-through' : 'fw-bold'} fs-4`}>{d.price}</span>
                                                    <span className='text-danger mx-2 fw-bold'>{d.discounted_price > 0 && (d.price - d.discounted_price)}</span>
                                                </div>
                                            </Col>
                                        </Row>
                                        <div>
                                            <h5>Description:</h5>
                                            {d.details === null ? (
                                                <p className='text-center my-3'>No Description</p>
                                            ) : (
                                                <p>{d.details}</p>
                                            )}

                                        </div>
                                    </Card>
                                </Col>
                                <Col md="4">
                                    {
                                        d.seller_store_number > 0 ?
                                            <Card className='border-0'>
                                                <h4>Shop Info</h4>
                                                <hr />
                                                <div>
                                                    <img className='w-100' alt="img" src={d.seller_store_logo === null ? defaultImg : PF + d.seller_store_logo} />
                                                </div>
                                                <span className='my-3'><i class='bx bx-map'></i> {d.seller_store_address}</span>
                                                <span><i class='bx bx-phone'></i>{d.seller_store_number}</span>
                                                <h4 className='text-primary'>{d.seller_store_name}</h4>
                                                <div className='my-3 border-2 border-secondary'>
                                                    {d.seller_store_map_location !== null &&
                                                        <>
                                                            <ReactMapGL
                                                                mapboxAccessToken="pk.eyJ1Ijoic2hhaWJpIiwiYSI6ImNraGxqajRyeDB1M3oyd3MyaXE4MG0xZ20ifQ.PY_b9Dadqa6TmtUouX86Gw"
                                                                initialViewState={viewport}
                                                                mapStyle="mapbox://styles/mapbox/streets-v9"
                                                                style={{ position: "relative", height: '300px' }}
                                                            >
                                                                <Marker
                                                                    longitude={viewport.longitude}
                                                                    latitude={viewport.latitude}
                                                                    style={{ cursor: 'pointer' }}
                                                                // offsetLeft={-20}
                                                                // offsetTop={-10}
                                                                >
                                                                    <i class='bx bxs-map fs-3'></i>
                                                                </Marker>
                                                            </ReactMapGL>
                                                        </>
                                                    }
                                                </div>
                                            </Card>
                                            :
                                            <Card className='border-0'>
                                                <h4>Shop Info</h4>
                                                <hr />
                                                <div>
                                                    <img className='w-100' alt="img" src={d.service_provider_display_images === null ? defaultImg : PF + d.service_provider_display_images} />
                                                </div>
                                                <span><i class='bx bx-phone'></i>{d.service_provider_number}</span>
                                                <h4 className='text-primary'>{d.name}</h4>
                                                <h4 className='text-primary'>{d.service_provider_email}</h4>
                                                <div className='my-3 border-2 border-secondary'>
                                                    {d.service_provider_map_location !== null &&
                                                        <>
                                                            <ReactMapGL
                                                                mapboxAccessToken="pk.eyJ1Ijoic2hhaWJpIiwiYSI6ImNraGxqajRyeDB1M3oyd3MyaXE4MG0xZ20ifQ.PY_b9Dadqa6TmtUouX86Gw"
                                                                initialViewState={viewport}
                                                                mapStyle="mapbox://styles/mapbox/streets-v9"
                                                                style={{ position: "relative", height: '300px' }}
                                                            >
                                                                <Marker
                                                                    longitude={viewport.longitude}
                                                                    latitude={viewport.latitude}
                                                                    style={{ cursor: 'pointer' }}
                                                                // offsetLeft={-20}
                                                                // offsetTop={-10}
                                                                >
                                                                    <i class='bx bxs-map fs-3'></i>
                                                                </Marker>
                                                            </ReactMapGL>
                                                        </>
                                                    }
                                                </div>
                                            </Card>
                                    }

                                </Col>
                            </Row>
                        </>))
                    ) : (
                        <div>
                            <h1>No product</h1>
                        </div>
                    )
            }

        </Container>
    )
}